const checkboxes = document.querySelectorAll('.fqt__product__checkbox input[type="checkbox"]');
const addTocartSubmit = document.querySelector(".frequently__bought__together__conent .fqt_button");

const productArr = [];

let addToCartDisbaled = () => {
  if (productArr.length < 1) {
    addTocartSubmit.setAttribute("disabled", "disabled");
  } else {
    addTocartSubmit.removeAttribute("disabled");
  }
}

for (const checkbox of checkboxes) {
  checkbox.addEventListener("input", () => {
    const parent = checkbox.closest(".fqt__product__checkbox");
    const variant = parent.dataset.variant;
    
    if (checkbox.checked) {
      parent.classList.add("active");
      if (!productArr.includes(variant)) {
        productArr.push(variant);
      }
    } else {
      parent.classList.remove("active");
      const index = productArr.indexOf(variant);
      if (index !== -1) {
        productArr.splice(index, 1);
      }
    }
    addToCartDisbaled();
  });
}

addTocartSubmit.addEventListener("click", (event) => {
  const loadingSpinner = addTocartSubmit.querySelector(".loading__spinner");
  const originalFontSize = addTocartSubmit.style.fontSize;

  if (addTocartSubmit.hasAttribute("disabled")) {
    event.preventDefault();
    return;
  }

  if (loadingSpinner) {
    loadingSpinner.classList.remove("hidden");
  }

  addTocartSubmit.style.fontSize = "0px";
  addToCart();

  setTimeout(() => {
    if (loadingSpinner) {
      loadingSpinner.classList.add("hidden");
    }
    addTocartSubmit.style.fontSize = originalFontSize;
  }, 1000);
});

let addToCart = () => {
  let formData = {
    'items': productArr.map(variant => ({
      'id': variant,
      'quantity': 1
    }))
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
      cartDrawerUpdate();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

let cartDrawerUpdate = () => {
  fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch cart drawer items: ${response.status}`);
      }
      return response.text();
    })
    .then((responseText) => {
      const parser = new DOMParser();
      const html = parser.parseFromString(responseText, "text/html");
      const updatedSection = html.querySelector("cart-drawer");
      const currentSection = document.querySelector("cart-drawer");
      if (updatedSection && currentSection) {
        currentSection.replaceWith(updatedSection);
         const cartDrawer = document.querySelector('cart-drawer.drawer');
        cartDrawer.classList.add('active'); 
      } else {
        console.warn("cart-drawer-items section not found in the DOM or response.");
      }
    })
    .catch((error) => {
      console.error("Error reloading cart drawer items:", error);
    });
}

